// Updated Forex.js with rerender fix
import React, { useEffect, useState, useCallback } from "react";
import "./Forex.css";
import add from "../../images/save.png";
import remove from "../../images/remove.png";
import { Button, Modal } from "react-bootstrap";
import instance from "../../services/baseService";
import CurrencyDropdown from "./CurrencyDropdown";
import Base from "../Base";
import toast from 'react-hot-toast';

const today = new Date();

const OffcanvasContent = React.memo(({
  isOffcanvasOpen,
  setIsOffcanvasOpen,
  currencies,
  currencyData,
  validationErrors,
  handleCurrencyChange,
  handleAddCurrency,
  handleRemoveCurrency,
  handleSubmit,
  date,
  dateHandler,
  showSuccessModal,
  handleCloseSuccessModal
}) => (
  <>
    {isOffcanvasOpen && (
      <div className="fixed inset-0 bg-black bg-opacity-50 z-40" onClick={() => setIsOffcanvasOpen(false)} />
    )}
    <div className={`fixed top-0 right-0 h-full bg-white shadow-xl transform transition-transform duration-300 ease-in-out z-50 ${isOffcanvasOpen ? 'translate-x-0' : 'translate-x-full'}`}>
      <div className="flex justify-between items-center p-4 border-b border-gray-200 bg-gray-50">
        <h3 className="text-sm !text-[24px] text-gray-800">Add Forex Rates</h3>
        <button type="button" onClick={() => setIsOffcanvasOpen(false)} className="btn-close" aria-label="Close"></button>
      </div>
      <div className="p-4 overflow-y-auto h-full pb-20">
        <form onSubmit={handleSubmit}>
          <div className="flex items-center justify-between mb-2">
            <h4 className="text-md !text-[20px] text-gray-800">Currency List</h4>
            <img src={add} alt="Add" style={{ width: '30px', height: '30px' }} className="cursor-pointer hover:opacity-80" onClick={handleAddCurrency} />
          </div>
          <div className="form-group date-pick mb-4 mt-1 max-w-[240px]">
            <label
                htmlFor="date"
                className="block text-[15px] font-semibold text-gray-700 mb-0.5 mr-4"
              >
                Date
              </label>
            <input type="date" id="date" name="date" value={date} onChange={dateHandler} className="form-control w-full px-2 py-2 pr-10 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0d4473] focus:border-transparent" />
          </div>

          <div className="space-y-4 max-h-96 overflow-y-auto">
            {currencies.map((currency, index) => (
              <div key={index} className="currency-row border border-gray-200 rounded-lg p-3 bg-gray-50">
                <div className="form-group mb-3">
                  <label htmlFor={`currency-code-${index}`} className="block text-base font-bold text-gray-700 mb-2">Currency Code</label>
                  <CurrencyDropdown
                    index={index}
                    currency={currency}
                    handleCurrencyChange={handleCurrencyChange}
                    currencyData={currencyData}
                  />
                  {validationErrors[index] && validationErrors[index].currency && (
                    <p className="text-red-500 text-sm mt-1">{validationErrors[index].currency}</p>
                  )}
                </div>
                <div className="form-group mb-3">
                  <label htmlFor={`currency-amount-${index}`} className="block text-base font-bold text-gray-700 mb-2">Amount</label>
                  <input
                    type="text"
                    id={`currency-amount-${index}`}
                    placeholder="Enter Amount"
                    value={currency.amount}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === '' || /^\d*\.?\d{0,2}$/.test(value)) {
                        handleCurrencyChange(index, "amount", value);
                      }
                    }}
                    className="form-control w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0d4473] focus:border-transparent"
                  />
                  {validationErrors[index] && validationErrors[index].amount && (
                    <p className="text-red-500 text-sm mt-1">{validationErrors[index].amount}</p>
                  )}
                </div>
                {currencies.length > 1 && (
                  <div className="flex justify-end">
                    <img src={remove} alt="Remove" className="w-6 h-6 cursor-pointer hover:opacity-80" onClick={() => handleRemoveCurrency(index)} />
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="form-group mt-6 text-center">
            <Button type="submit" className="save-btn !w-[40%] bg-[#0d4473] border-[#0d4473] hover:bg-[#0a3a5e] text-white py-2 rounded-md">
              Save
            </Button>
          </div>
        </form>
      </div>
    </div>
  </>
));

const Forex = ({ isOffcanvasOpen = false, setIsOffcanvasOpen = () => { }, showMainContent = true }) => {
  const [currencies, setCurrencies] = useState([{ currency: "", amount: "" }]);
  const [date, setDate] = useState(today.toISOString().split("T")[0]);
  const [currencyData, SetCurrencyData] = useState([]);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [validationErrors, setValidationErrors] = useState([]);

  useEffect(() => {
    if (isOffcanvasOpen) fetchCurrency();
  }, [isOffcanvasOpen]);

  const fetchCurrency = async () => {
    try {
      const [currencyDataResponse, currenciesResponse] = await Promise.all([
        instance.post(`/api/v1/forex/list`, { page: 1, perpage: 25 }),
        instance.post(`/api/v1/forex/added/list`, { current_date: date }),
      ]);
      const currencyList = currenciesResponse.data.data.list;
      setCurrencies(currencyList.length > 0 ? currencyList : [{ currency: "", amount: "" }]);
      SetCurrencyData(currencyDataResponse.data.data.list);
    } catch (error) {
      console.error("Error fetching messages:", error);
    }
  };

  const handleAddCurrency = useCallback(() => {
    setCurrencies(prev => [...prev, { currency: "", amount: "" }]);
    setValidationErrors(prev => [...prev, {}]);
  }, []);

  const handleRemoveCurrency = useCallback(index => {
    setCurrencies(prev => prev.filter((_, i) => i !== index));
    setValidationErrors(prev => prev.filter((_, i) => i !== index));
  }, []);

  const handleCurrencyChange = useCallback((index, field, value) => {
    setCurrencies(prev => prev.map((c, i) => i === index ? { ...c, [field]: value } : c));
    setValidationErrors(prev => {
      const newErrors = [...prev];
      if (newErrors[index]) newErrors[index][field] = '';
      return newErrors;
    });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = currencies.map(c => {
      const errors = {};
      if (!c.currency) errors.currency = "Currency code is required.";
      if (!c.amount) errors.amount = "Amount is required.";
      else if (parseFloat(c.amount) <= 0) errors.amount = "Amount must be positive.";
      return errors;
    });

    setValidationErrors(newErrors);
    if (newErrors.some(err => Object.keys(err).length > 0)) return;

    try {
      const response = await instance.post(`/api/v1/forex/bulk/create`, { date, forex_data: currencies });
      toast.success("Successfully created forex data");
      setCurrencies(response.data.data);
      setIsOffcanvasOpen(false);
      setValidationErrors([]);
      setShowSuccessModal(true);
    } catch (error) {
      console.error("Error submitting forex data:", error);
    }
  };

  const dateHandler = async (e) => {
    const newDate = e.target.value;
    setDate(newDate);
    try {
      const currenciesResponse = await instance.post(`/api/v1/forex/added/list`, { current_date: newDate });
      const currencyList = currenciesResponse.data.data.list;
      setCurrencies(currencyList.length > 0 ? currencyList : [{ currency: "", amount: "" }]);
      setValidationErrors(currencyList.map(() => ({})));
    } catch (error) {
      console.error("Error changing date:", error);
    }
  };

  if (!showMainContent) {
    return (
      <OffcanvasContent
        isOffcanvasOpen={isOffcanvasOpen}
        setIsOffcanvasOpen={setIsOffcanvasOpen}
        currencies={currencies}
        currencyData={currencyData}
        validationErrors={validationErrors}
        handleCurrencyChange={handleCurrencyChange}
        handleAddCurrency={handleAddCurrency}
        handleRemoveCurrency={handleRemoveCurrency}
        handleSubmit={handleSubmit}
        date={date}
        dateHandler={dateHandler}
        showSuccessModal={showSuccessModal}
        handleCloseSuccessModal={() => setShowSuccessModal(false)}
      />
    );
  }

  return (
    <Base hideDatepicker={true}>
      <div className="w-full h-full flex">
        <OffcanvasContent
          isOffcanvasOpen={isOffcanvasOpen}
          setIsOffcanvasOpen={setIsOffcanvasOpen}
          currencies={currencies}
          currencyData={currencyData}
          validationErrors={validationErrors}
          handleCurrencyChange={handleCurrencyChange}
          handleAddCurrency={handleAddCurrency}
          handleRemoveCurrency={handleRemoveCurrency}
          handleSubmit={handleSubmit}
          date={date}
          dateHandler={dateHandler}
          showSuccessModal={showSuccessModal}
          handleCloseSuccessModal={() => setShowSuccessModal(false)}
        />
      </div>
    </Base>
  );
};

export default Forex;